import AddStudents from "components/AddStudents/AddStudents";



const AddStudentsPage: React.FC = () => {
  return <AddStudents />;
};

export default AddStudentsPage;